import { render, staticRenderFns } from "./TotalProductType.vue?vue&type=template&id=5918ac59&"
import script from "./TotalProductType.vue?vue&type=script&lang=js&"
export * from "./TotalProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports